import type { DatabaseBlockModel } from '@blocksuite/affine-model';
import { SignalWatcher, WithDisposable } from '@blocksuite/global/lit';
import { type EditorHost, ShadowlessElement } from '@blocksuite/std';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';

export class EdgelessDatabaseMask extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  override render() {
    const borderRadius = 12;

    return html`
      <div
        class="affine-database-mask"
        style=${styleMap({
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: '1',
          pointerEvents:
            this.editing || this.disableMask || this.passthrough
              ? 'none'
              : 'auto',
          borderRadius: `${borderRadius * this.zoom}px`,
        })}
      ></div>
    `;
  }

  @property({ attribute: false })
  accessor disableMask!: boolean;

  @property({ attribute: false })
  accessor editing!: boolean;

  @property({ attribute: false })
  accessor host!: EditorHost;

  @property({ attribute: false })
  accessor model!: DatabaseBlockModel;

  @property({ attribute: false })
  accessor passthrough = false;

  @property({ attribute: false })
  accessor zoom!: number;
}

declare global {
  interface HTMLElementTagNameMap {
    'edgeless-database-mask': EdgelessDatabaseMask;
  }
}
